/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { observer } from 'mobx-react';
import { Message } from '../../../../../types/Message';
import { Box, CircularProgress, Divider, IconButton, Input } from '@mui/material';
import SendIcon from '@mui/icons-material/SendRounded';
import React from 'react';
import ChatViewStyles from '../ChatViewStyles';
import { useViewModel } from '../../../../../hooks/useViewModel';
import { autorun } from 'mobx';
import { ChatBoxViewModel } from './ChatBoxViewModel';
import ChatMessageView from '../ChatMessage/ChatMessageView';

const ChatBoxView = observer(() => {
	const { classes } = ChatViewStyles();
	const viewModel: ChatBoxViewModel = useViewModel(ChatBoxViewModel);
	let roomKey: string = viewModel.getActiveChat();

	autorun(() => {
		viewModel.subscribeToChatRoomEvent().forEach(() => {
			roomKey = viewModel.getActiveChat();
		});
	});

	return (
		<Box className={classes.chat}>
			<Box className={classes.messageBox}>
				{viewModel.areMessagesFetching() ? (
					<Box className={classes.loadingContainer}>
						<CircularProgress className={classes.loading} />
					</Box>
				) : (
					viewModel
						.getMessages(roomKey)
						.slice()
						.reverse()
						.map((message: Message) => <ChatMessageView message={message} key={message.identifier} />)
				)}
			</Box>
			<Divider variant='fullWidth' />
			<form
				onSubmit={(e) => {
					e.preventDefault();
					viewModel.sendMessage();
				}}>
				<Box className={classes.sendMessageContainer}>
					<Input
						autoFocus={true}
						inputProps={{ className: classes.chatText }}
						placeholder={'Write a message...'}
						className={classes.input}
						disableUnderline={true}
						value={viewModel.getMessage()}
						onChange={(event) => viewModel.changeMessage(event)}
					/>
					<IconButton type={'submit'} className={classes.sendButton}>
						<SendIcon className={classes.sendIcon} />
					</IconButton>
				</Box>
			</form>
		</Box>
	);
});

export default ChatBoxView;
